// extracted by mini-css-extract-plugin
export default {"image":"ThinkingImage_image__2Hhgm"};